import Vue from 'vue';
import Vuex from 'vuex';
import { FEATURE_FLAGS__GET_FLAGS } from '@/store/types';
import { auth } from './modules/auth/auth';
import { billingHistory } from './modules/billing-history/billing-history';
import { conversation } from './modules/conversation/conversation';
import { customerLeads } from './modules/customerLeads/customerLeads';
import { dispute } from './modules/dispute/dispute';
import { featureFlags } from './modules/feature-flags/feature-flags';
import { instantQuote } from './modules/instant-quote/instant-quote';
import { ltrs } from './modules/ltrs/ltrs';
import { myServices } from './modules/my-services/my-services';
import { propertyManager } from './modules/property-manager/property-manager';
import { onboarding } from './modules/onboarding/onboarding';
import { orderServices } from './modules/order-services/order-services';
import { profile } from './modules/profile/profile';
import { properties } from './modules/properties/properties';
import { reactivation } from './modules/reactivation/reactivation';
import { recommendations } from './modules/recommendations/recommendations';
import { requiredServices } from './modules/required-services/required-services';
import { review } from './modules/review/review';
import { schedules } from './modules/schedules/schedules';
import { scheduleCycles } from './modules/scheduleCycles/scheduleCycles';
import { screenSize } from './modules/screen-size/screen-size';
import { serviceHistory } from './modules/service-history/service-history';
import { share } from './modules/share/share';
import { support } from './modules/support/support';
import { termsOfService } from './modules/terms-of-service/terms-of-service';
import { longGrass } from './modules/long-grass/long-grass';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    auth,
    billingHistory,
    conversation,
    customerLeads,
    dispute,
    featureFlags,
    instantQuote,
    ltrs,
    myServices,
    propertyManager,
    onboarding,
    orderServices,
    profile,
    properties,
    reactivation,
    recommendations,
    requiredServices,
    review,
    schedules,
    scheduleCycles,
    screenSize,
    serviceHistory,
    share,
    support,
    termsOfService,
    longGrass,
  },
});

store.dispatch(FEATURE_FLAGS__GET_FLAGS);

export default store;
